// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Pager Input Component */
:host(ids-pager-input) {
  display: inline-flex;
  align-items: center;
}

.ids-pager-input,
ids-input::part(container) {
  margin-inline-start: var(--ids-space-2xs);
  margin-inline-end: var(--ids-space-2xs);
  margin-block-end: 0;
}

.ids-pager-input input,
ids-input::part(input) {
  padding-block-start: 0;
  padding-block-end: 0;
  margin-block-end: 0;
  min-width: var(--ids-space-xl);
}

.ids-pager-input label,
ids-input::part(label) {
  margin-block-end: 0;
  height: 0;
}

.ids-pager-input,
ids-input::part(field-container) {
  margin-block-end: 0;
}

ids-text {
  margin-inline-start: var(--ids-space-2xs);
  margin-inline-end: var(--ids-space-2xs);
}

ids-input[size=xs]::part(field-container),
.ids-input.xs .field-container {
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-pager/ids-pager-input.scss"],"names":[],"mappings":"AAAA,8BAAA;AACA;EACE,oBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,yCAAA;EACA,uCAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,8BAAA;AACF;;AAEA;;EAEE,mBAAA;EACA,SAAA;AACF;;AAEA;;EAEE,mBAAA;AACF;;AAEA;EACE,yCAAA;EACA,uCAAA;AACF;;AAGA;;EAEE,WAAA;AAAF","sourcesContent":["/* Ids Pager Input Component */\n:host(ids-pager-input) {\n  display: inline-flex;\n  align-items: center;\n}\n\n.ids-pager-input,\nids-input::part(container) {\n  margin-inline-start: var(--ids-space-2xs);\n  margin-inline-end: var(--ids-space-2xs);\n  margin-block-end: 0;\n}\n\n.ids-pager-input input,\nids-input::part(input) {\n  padding-block-start: 0;\n  padding-block-end: 0;\n  margin-block-end: 0;\n  min-width: var(--ids-space-xl);\n}\n\n.ids-pager-input label,\nids-input::part(label) {\n  margin-block-end: 0;\n  height: 0;\n}\n\n.ids-pager-input,\nids-input::part(field-container) {\n  margin-block-end: 0;\n}\n\nids-text {\n  margin-inline-start: var(--ids-space-2xs);\n  margin-inline-end: var(--ids-space-2xs);\n}\n\n// Remove automatic width on \"xs\"-sized pager inputs\nids-input[size='xs']::part(field-container),\n.ids-input.xs .field-container {\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
